import { StockDetailAccordionRow } from './StockDetailAccordionRow.component';
import { StockDetailTableHeader, StockDetailTableRow } from './StockDetailTableRow.component';
import { StockHomeAccordionRow } from './StockHomeAccordionRow.component';
import React, { FC } from 'react';
import { getStocksTableElements, StocksTableInformationArgs } from '@stocks/business/StocksTable.utils';

export const StocksRow: FC<StocksTableInformationArgs> = ({
  productType,
  product: productFromArgs,
  screen,
  onShowGraph,
  rowForm,
  tableHeader,
  ...rest
}) => {
  const product = productFromArgs ? productFromArgs : productType.products[0];

  const { elements, firstElement, linkProps } = getStocksTableElements({ product, productType, screen, ...rest });

  if (screen === 'stockHome') {
    return (
      <StockHomeAccordionRow
        firstElement={firstElement}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        linkProps={linkProps!}
        productType={productType}
      />
    );
  }
  if (screen === 'stockDetail') {
    if (rowForm === 'accordion') {
      return (
        <StockDetailAccordionRow
          elements={elements}
          firstElement={firstElement}
          onShowGraph={onShowGraph}
          product={product}
        />
      );
    }
    if (tableHeader) {
      return <StockDetailTableHeader elements={elements} firstElement={firstElement} />;
    }
    return (
      <StockDetailTableRow
        elements={elements}
        firstElement={firstElement}
        onShowGraph={onShowGraph}
        product={product}
      />
    );
  }
  const ifTest: never = screen;
  return ifTest;
};
